import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-sucees-changepassword',
  templateUrl: './sucees-changepassword.component.html',
  styleUrls: ['./sucees-changepassword.component.scss'],
})
export class SuceesChangepasswordComponent implements OnInit {
  bodyText = '';
  IsForcePasswordUpdate: boolean = false;
  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.IsForcePasswordUpdate = this.config.data.IsForcePasswordUpdate;
  }

  continue(): void {
    this.ref.close();
    if (this.IsForcePasswordUpdate) {
      this.navigateToLoginPage();
    }
  }
  navigateToLoginPage() {
    if (this.IsForcePasswordUpdate) {
      this.router.navigateByUrl('/login');
      localStorage.clear();
    }
  }
}
